module.exports = __webpack_public_path__ + "media/images/guide/image6-9dc910fd6878be186e259fd245bce3e9.png";